import * as api from '../api/interactions.js';
import q from '../query.js';
import keys from '@debbie/common/dist/cache/keys.js';
export const interactionsEntity = `interactions`;
export const interactionInsightsTotalsKey = `interaction-insights-totals`;
export const useInteractionInsightsTotals = () => q.query(interactionInsightsTotalsKey, api.getInsightsTotals, keys.read.collection(interactionsEntity));
export const interactionsByReferenceKey = (referenceType, referenceId) => `interaction-by-reference-${referenceType}-${referenceId}`;
export const useInteractionsByReference = (referenceType, referenceId, casualConsistency) => q.query(interactionsByReferenceKey(referenceType, referenceId), () => referenceId
    ? api.getByReferenceId(referenceType, referenceId)
    : null, keys.read.collection(interactionsEntity));
//# sourceMappingURL=index.js.map